module.exports = __webpack_public_path__ + "img/lantern.ae703eb0.png";